'use client';

import { c as _c } from "react/compiler-runtime";
import { useConfig } from '@/hooks/use-config';
import { useProjectsContext } from '@/providers/projects-provider';
import type { ShellTourOptions } from './shell-tour-steps';
export function useShellTourOptions() {
  const $ = _c(4);
  const {
    selectedProject,
    projectId
  } = useProjectsContext();
  const configProjectId = selectedProject?.mappedProjectId ?? projectId;
  const {
    data: projectConfig,
    isLoadingData
  } = useConfig(configProjectId);
  if (!selectedProject) {
    return null;
  }
  const audience = selectedProject.product === "internal" ? "employee" : "customer";
  if (audience === "employee" && (isLoadingData || !projectConfig)) {
    return null;
  }
  const t0 = projectConfig?.roi_settings?.enabled ?? false;
  const t1 = projectConfig?.aifi_settings?.enabled ?? false;
  let t2;
  if ($[0] !== audience || $[1] !== t0 || $[2] !== t1) {
    t2 = {
      audience,
      isRoiEnabled: t0,
      isProficiencyEnabled: t1
    };
    $[0] = audience;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}